import React from 'react';
import {
  Link,
} from 'react-router';

import './style.scss';
import Header from '../../components/header';
import Url from '../../lib/url';

const App = (props) => {
  const appId = props.params.appId;
  return (
    <main className="appWrapper">
      <Header>Ciao</Header>
      <Link to={`${Url.order(appId)}`}>Ordina online</Link>
      <Link to={`${Url.booking(appId)}`}>Prenota online</Link>
    </main>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/app/index.js